import { Survey } from '@/types/api';

interface SurveysState {
  data: Survey[];
  loading: boolean;
  error: boolean;
}

const defaultState: SurveysState = {
  data: [],
  loading: false,
  error: false,
};

const surveys = function (state: SurveysState = defaultState, action: any): SurveysState {
  let data: Survey[], target: number;

  switch (action.type) {
    case 'SET_CAMPAIGN_SURVEYS':
      return { ...state, data: action.data };

    case 'UPDATE_SURVEY':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case 'REMOVE_SURVEY':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case 'INSERT_SURVEY':
      return { ...state, data: [...state.data, action.data] };

    case 'SET_CAMPAIGN_SURVEYS_LOADING':
      return { ...state, loading: action.data };

    case 'SET_CAMPAIGN_SURVEYS_ERROR':
      return { ...state, error: action.data };

    default:
      return state;
  }
};

export default surveys;
